import React, { FC } from "react";
import NewLayerStepActions, { NewLayerStepActionsProps } from "./NewLayerStepActions";
import { NewLayerStepTitle } from "./NewLayerStepTitle";
import { ContentWrapper } from "./styled";

export const NewLayerWizardStep: FC<NewLayerStepActionsProps> = ({ children, ...props }) => {
  return (
    <>
      <NewLayerStepTitle />
      <ContentWrapper>{children}</ContentWrapper>
      <NewLayerStepActions {...props} />
    </>
  );
};
